import {Component, MeshComponent} from '@wonderlandengine/api';
import {roundedRectangle} from './rounded-rectangle-mesh.js';

/**
 * input-field
 */
export class InputField extends Component {
    static TypeName = 'input-field';

    start() {
        const meshComp = this.object.getComponent(MeshComponent)!;
        meshComp.mesh = roundedRectangle(this.engine, 0.7, 0.15, 0.05, 6);
    }

    update(dt: number) {
        /* Called every frame. */
    }
}
